<ng-container *ngIf="roleService.onlySourceSite$ | async">
  <span class="portal-label portal-btn mat-button">
    <ng-container *ngTemplateOutlet="sourceSiteLabel"></ng-container>
  </span>
</ng-container>

<ng-container *ngIf="roleService.onlyFillSite$ | async">
  <span class="portal-label portal-btn mat-button">
    <ng-container *ngTemplateOutlet="fillSiteLabel"></ng-container>
  </span>
</ng-container>

<button mat-button *ngIf="roleService.isQPorBothSites$ | async" [matMenuTriggerFor]="menu" [ngSwitch]="portal$ | async" class="portal-btn">
  <ng-container *ngSwitchCase="PortalState.SOURCE_SITE">
    <ng-container *ngTemplateOutlet="sourceSiteLabel"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="PortalState.FILL_SITE">
    <ng-container *ngTemplateOutlet="fillSiteLabel"></ng-container>
  </ng-container>
  <span class="dropdn-arw"><img src="assets/svg/icons/arrow.svg"/></span>
</button>
<mat-menu #menu="matMenu">
  <div class="site-portal">
    <ng-container *ngTemplateOutlet="sourceSites"></ng-container>
    <ng-container *ngTemplateOutlet="fillSites"></ng-container>
  </div>
</mat-menu>

<ng-template #sourceSites>
  <button mat-button class="site-portal__option" (click)="setSourceSites()">
    <ng-container *ngTemplateOutlet="sourceSiteLabel"></ng-container>
  </button>
</ng-template>

<ng-template #fillSites>
  <button mat-button class="site-portal__option" (click)="setFillSites()">
    <ng-container *ngTemplateOutlet="fillSiteLabel"></ng-container>
  </button>
</ng-template>

<ng-template #sourceSiteLabel>
  <ng-container *ngTemplateOutlet="label; context: { $implicit: { title: 'Source Site Portal' } }"></ng-container>
</ng-template>
<ng-template #fillSiteLabel>
  <ng-container *ngTemplateOutlet="label; context: { $implicit: { title: 'Receiving Site Portal' } }"></ng-container>
</ng-template>

<ng-template #label let-header>
  <span class="portal-notifctn-dot"></span>
  <span class="float-left">
    <h4>{{ header.title }}</h4>
  </span>
</ng-template>
